<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.5 21.875V13.2812M16.4062 21.875V13.2812M8.59375 21.875V13.2812M3.125 9.375L12.5 3.125L21.875 9.375M20.3125 21.875V10.763C17.767 10.3636 15.1577 10.1562 12.5 10.1562C9.8423 10.1562 7.23304 10.3636 4.6875 10.763V21.875M3.125 21.875H21.875M12.5 7.03125H12.5078V7.03906H12.5V7.03125Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgLibrary',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
